(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// Page BUilder
//
// ------------------------------------

(function ($) {

    if (typeof window.TheChurchCo_NewContent == 'undefined') window.TheChurchCo_NewContent = {};

    TheChurchCo_NewContent = {

        posttypes: [
            { type: 'page', route: '/api/v1/page', title: 'Page' },
            { type: 'post', route: '/api/v1/blogcreate', title: 'Blog' },
            { type: 'events', route: '/api/v1/event', title: 'Event' },
            { type: 'podcasts', route: '/api/v1/podcastepisodecreate', title: 'Episode' },
            { type: 'group', route: '/api/v1/group', title: 'Group' },
            { type: 'prayer-request', route: '/api/v1/prayer/create', title: 'Prayer Request' },
            { type: 'note', route: '/api/v1/note/create', title: 'Note' }

        ],
        active: null,

        // ------------------------------------
        // Init
        // ------------------------------------

        init: function () {

            let item = this.posttypes.map(i => {
                if ($(`.no-touch body.post-type-${i.type}`).length > 0) {
                    TheChurchCo_NewContent.active = i;
                }
                return false;
            })

            if (!TheChurchCo_NewContent.active) return;

            // if (item[0]) this.body = item[0];
            // else return false;
            this.body = $(`.no-touch body.post-type-${TheChurchCo_NewContent.active.type}`);//$('.no-touch body.post-type-page');
            if (!this.body.length) return;

            // Create A New Content Modal
            this.createModal();

            // Create A New Content Trigger
            this.createTrigger();

        },



        createTrigger(type) {

            // Remove The Default Add New Button.
            this.defaultNewButton = $('.page-title-action');

            // Create a New Button
            this.newButton = $(`<a href="${this.defaultNewButton.attr('href')}" class="button" data-new-content-modal style="text-transform:capitalize">Add New ${TheChurchCo_NewContent.active.title}</a>`);

            // Insert New Button
            this.newButton.insertAfter(this.defaultNewButton);

            // Remove Default Button
            this.defaultNewButton.remove();

            // Events
            this.newButton.on('click', TheChurchCo_NewContent.toggle)

        },

        createModal() {

            let modalMarkup = `<div class="tcc-modal">
                <div class="tcc-modal-content">
                    <div class="tcc-modal-controls">
                        <a href="#" class="tcc-modal-close"><span class="icon icon-cancel"></span></a>
                    </div>
                    <div class="tcc-modal-body">
                        <div class="panel">
                            <div class="panel-header">
                                <h1 style="text-transform:capitalize">New ${TheChurchCo_NewContent.active.title}</h1>
                                <p>Give your ${TheChurchCo_NewContent.active.title} a title and click create</p>
                            </div>
                            <div class="panel-body">
                                <div class="tcc-form-field">
                                    <label>Title</label>
                                    <input type="text" name="newcontenttitle" size="30" value="" id="title" spellcheck="true" autocomplete="off" required>
                                    <button class="button -full button-primary primary create-new-content">Create</button>
                                </div>
                                
                            </div>
                        </div>
                        <div class="tccspinner" style="display:none;"></div>
                    </div>
                </div>
            </div>`;

            this.modal = $(modalMarkup);
            this.modal.find('.tcc-modal-close').on('click', TheChurchCo_NewContent.toggle)

            // Grab Elements
            this.titleInput = this.modal.find('input[name="newcontenttitle"]');
            this.createButton = this.modal.find('.create-new-content');
            this.panel = this.modal.find('.panel');
            this.loader = this.modal.find('.tccspinner');

            // Add Save Event
            this.createButton.on('click', TheChurchCo_NewContent.create);

            // Add To Body
            this.body.append(this.modal);

        },

        toggle(e) {

            if (e) e.preventDefault();

            if (TheChurchCo_NewContent.newButton.hasClass('-open')) {
                TheChurchCo_NewContent.onClose();
            } else {
                TheChurchCo_NewContent.onOpen();
            }

            TheChurchCo_NewContent.modal.toggleClass('-open');
            TheChurchCo_NewContent.newButton.toggleClass('-open');
            $('body').toggleClass('new-content-open')

        },

        onClose() { },
        onOpen() { },

        create(e) {
            e.preventDefault();
            TheChurchCo_NewContent.panel.fadeOut();
            TheChurchCo_NewContent.loader.fadeIn();
            let data = {};
            data.title = TheChurchCo_NewContent.titleInput.val();

            if (!data.title) {
                TheChurchCo_NewContent.panel.fadeIn();
                TheChurchCo_NewContent.loader.fadeOut();
                return false;
            }

            // Save Data
            // fetch('/api/v1/page')
            fetch(TheChurchCo_NewContent.active.route, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: "POST",
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(response => {

                    if (response.status !== 'success') {
                        TheChurchCo_NewContent.panel.fadeIn();
                        TheChurchCo_NewContent.loader.fadeOut();
                        return;
                    }
                    // Redirect to Visual Editor
                    let url = '';
                    // if (response.visual_editor) url = response.visual_editor;
                    if (response.classic_editor) url = response.classic_editor;
                    else '/wp-admin/edit.php?post_type=' + TheChurchCo_NewContent.active.type;

                    if (TheChurchCo_NewContent.active.type === 'page' && response.visual_editor) url = response.visual_editor

                    // Go
                    window.parent.location.href = url;

                }).catch(e => {
                    TheChurchCo_NewContent.panel.fadeIn();
                    TheChurchCo_NewContent.loader.fadeOut();
                })

        }


    };


    module.exports = TheChurchCo_NewContent;

})(jQuery);

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/new-content.js","/modules")